/**
 * Built-in defaults for the editable Home page content block (`home`).
 *
 * Currently covers the "Elite Partners" section. Mirrors the previously
 * hardcoded content so the home page renders identically until an admin saves
 * a customisation. Shared by the public component
 * (`components/home/PartnersSection.jsx`) and the admin editor
 * (`admin/pages/PageHome.jsx`).
 */

export const ELITE_PARTNERS_DEFAULTS = {
  eyebrow: 'Elite Partners',
  title: 'World-Class Organizing & Publication Partners.',
  lead: 'ISBM 2026 is delivered in collaboration with leading academic and industry organizations.',
  partners: [
    { label: 'Local Organizing Partner', logo: '/assets/images/logo/new-iadd-logo.webp', alt: 'IADD — International Auditors for Digital and Data Management Association' },
    {
      label: 'Organized by',
      logo: '/assets/images/Conferences Logo.png',
      alt: 'GR Conferences',
      logoClassName: 'w-full h-auto max-h-none object-contain scale-[1.18] dark:invert',
      logoAreaClassName: 'min-h-[120px] sm:min-h-[132px] lg:min-h-[144px]',
      cardClassName: 'ring-1 ring-brand-200/40 dark:ring-brand-500/20',
      wide: true,
    },
    { label: 'Publication Partner', logo: '/assets/images/logo/new-springer-logo.webp', alt: 'Springer Nature', logoClassName: 'w-full object-contain scale-[1.4]' },
  ],
};

export const HOME_DEFAULTS = {
  elitePartners: ELITE_PARTNERS_DEFAULTS,
};
